import { j as i } from "../../../../_virtual/jsx-runtime.js";
import r from "styled-components";
import { Outlet as t } from "react-router-dom";
function s() {
  return /* @__PURE__ */ i.jsx(o, { children: /* @__PURE__ */ i.jsx(e, { children: /* @__PURE__ */ i.jsx(t, {}) }) });
}
const o = r.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: var(--white);
`, e = r.div`
  border-radius: 8px;
  border: 1px solid rgba(16, 41, 0, 0.2);
  padding: 32px 25px;
  min-width: 440px;
  position: relative;
  @media (max-width: 768px) {
    border-radius: 0;
    border: none;
    padding: 0;
    width: 90%;
    min-width: 90%;
  }
`;
export {
  s as default
};
